const CACHE_KEY = 'planPermissionsCache'

const parseScript = (scriptStr) => {
  if (!scriptStr || !scriptStr.trim()) return {}
  try { return JSON.parse(scriptStr) } catch {
    try {
      const sanitized = scriptStr.replace(
        /([{,]\s*)([\p{L}_][\p{L}\p{N}_]*)\s*:/gu,
        '$1"$2":'
      )
      return JSON.parse(sanitized)
    } catch { return {} }
  }
}

const DEFAULTS = {
  muralInterativo: true, interatividade: true, vitrine: true,
  previsao: true, mapas: true, transito: true, conteudos: true,
  podcast: true, robocast: true, listas: true,
  whatsapp: true, participacoes: true, relatorios: true, bi: true,
  marketing: false, // off por padrão — só visível via override ou plano
  berta: true, // Berta (redação): liberada para todas as contas; override do admin ou plano ainda desligam
  tv30: true, // TV 3.0: mesmo critério da Berta — todas as contas, desligável pelo admin ou pelo plano
}

// Synchronous read for non-React code (items.js).
// Returns cache written by usePlanPermissions hook, falls back to plan_script in user object.
// feature_overrides (set by admin per-user) win over the plan.
// Missing keys default to DEFAULTS value.
export const getPlanPermissions = () => {
  try {
    const user = JSON.parse(localStorage.getItem('user')) || {}
    const cached = localStorage.getItem(CACHE_KEY)
    const src = cached ? JSON.parse(cached) : parseScript(user.plan_script || '')
    const overrides = user.feature_overrides || {}

    const resolve = (key) => {
      if (key in overrides) return overrides[key]
      if (key in src) return src[key] !== false
      return DEFAULTS[key] !== false
    }

    return Object.fromEntries(Object.keys(DEFAULTS).map((k) => [k, resolve(k)]))
  } catch {
    return { ...DEFAULTS }
  }
}
